//TODO upgrade with RootState type
import { combineReducers } from '@reduxjs/toolkit';

import appReducer from 'app/containers/App/slice';
import sessionReducer from 'app/containers/auth/store/sessionSlice';
import reducerTasksetFilters from 'app/containers/taskSet/TaskSetQuickFilters/store/sliceTaskSetFilters';
import { gqlApi } from 'services/gqlApi';
import { restApi } from 'services/restApi';

import { InjectedReducersType, StaticReducersType } from './storeTypes';

const staticReducers: StaticReducersType = {
  app: appReducer,
  gqlApi: gqlApi.reducer,
  restApi: restApi.reducer,
  session: sessionReducer,
  tasksetFilters: reducerTasksetFilters,
};

const createReducer = (injectedReducers: InjectedReducersType = {}) => {
  // Initially we don't have any injectedReducers, so returning identity function to avoid the error
  if (Object.keys(injectedReducers).length === 0 && Object.keys(staticReducers).length === 0) {
    return (state: any) => state;
  } else {
    return combineReducers({
      ...staticReducers,
      ...injectedReducers,
    });
  }
};

export default createReducer;
